import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import Welcome from "./components/Welcome";
import Admin from "./components/Admin";
import GeneralAdser from "./components/GeneralAdser";
import GeneralSigma from "./components/GeneralSigma";
import Lider from "./components/Lider";
import Almacen from "./components/Almacen";
import Login from "./components/Login";
import Finanzas from "./components/Finanzas";
import Ingenieria from "./components/Ingenieria";
import Cliente from "./components/Cliente";
import Proveedor from "./components/Proveedor";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/cliente"
            element={
              <ProtectedRoute allowedRoles={["cliente"]}>
                <Cliente />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedor"
            element={
              <ProtectedRoute allowedRoles={["proveedor"]}>
                <Proveedor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ingenieria"
            element={
              <ProtectedRoute allowedRoles={["ingenieria"]}>
                <Ingenieria />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finanzas"
            element={
              <ProtectedRoute allowedRoles={["finanzas"]}>
                <Finanzas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general_adser"
            element={
              <ProtectedRoute allowedRoles={["general_adser"]}>
                <GeneralAdser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general_sigma"
            element={
              <ProtectedRoute allowedRoles={["general_sigma"]}>
                <GeneralSigma />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lider"
            element={
              <ProtectedRoute allowedRoles={["lider"]}>
                <Lider />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Admin/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/almacen"
            element={
              <ProtectedRoute allowedRoles={["almacen"]}>
                <Almacen/>
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Welcome />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
